export default "<app-loading *ngIf=\"loading\"></app-loading>\r\n<router-outlet (activate)=\"onActivate()\"></router-outlet>\r\n<app-footer></app-footer>"